import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getThunkResponse, usersURL } from "../app/api";
import { gsApi } from "../auth/auth";

export const selectUser = createAsyncThunk(
  "app/selectUser",
  async (userID, thunkAPI) => {
    let url = `${usersURL}/${userID}`;
    const response = await gsApi.get(url, { data: { include: "organization-users" } });
    return response;
  }
);

export const appSlice = createSlice({
  name: "app",
  initialState: {
    title: "Organization Management",
    currentUser: {},
    theme: "light",
    nav: [{ id: 1, label: "My Organizations", url: "/", isSelectable: true }],
    notifications: [],
    loading: [],
  },
  reducers: {
    setNav: (state, action) => {
      state.nav = action.payload;
    },
    toggleTheme: (state, action) => {
      state.theme = !state.theme;
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    addNotification: (state, action) => {
      state.notifications.unshift(action.payload);
    },
    removeNotification: (state, action) => {
      const newNotifications = state.notifications.filter(
        (not) => not.id !== action.payload.id
      );
      state.notifications = newNotifications;
    },
    clearNotifications: (state, action) => {
      state.notifications = [];
    },
  },
  extraReducers: {
    ...getThunkResponse(selectUser, (state, action) => {
      state.currentUser = action.payload
    }),
  },
});

export const {
  setNav,
  toggleTheme,
  addNotification,
  setNotifications,
  clearNotifications,
  removeNotification,
} = appSlice.actions;

export const selectNav = (state) => state.app.nav;
export const selectTitle = (state) => state.app.title;
export const selectAppNotifications = (state) => state.app.notifications;
export const selectTheme = (state) => state.app.theme;
export const selectCurrentUser = (state) => state.app.currentUser;

export default appSlice.reducer;
